/**
 * 重み付き乱択。乱数源は必ず引数で受ける（テストで決定的にするため）。
 */

/** 累積和 + 乱数 1 個で 1 件選ぶ。重みが全部 0 なら一様 */
export function weightedPick<T>(
  items: readonly T[],
  weight: (item: T) => number,
  rng: () => number
): T {
  if (items.length === 0) throw new Error('weightedPick: 候補が空');
  const weights = items.map((item) => Math.max(0, weight(item)));
  const total = weights.reduce((s, w) => s + w, 0);
  if (total <= 0) return items[Math.floor(rng() * items.length)];
  let r = rng() * total;
  for (let i = 0; i < items.length; i++) {
    r -= weights[i];
    if (r < 0) return items[i];
  }
  return items[items.length - 1]; // 丸め誤差で末尾に落ちたとき
}

/**
 * 重み付きシャッフル（Efraimidis–Spirakis）。key = u^(1/w) の降順に並べる。
 * 全要素の重みが等しいときは厳密に一様な順列になる。
 */
export function weightedShuffle<T>(
  items: readonly T[],
  weight: (item: T) => number,
  rng: () => number
): T[] {
  return items
    .map((item, i) => ({item, i, key: rng() ** (1 / Math.max(1e-9, weight(item)))}))
    .sort((a, b) => b.key - a.key || a.i - b.i)
    .map((x) => x.item);
}
